import { validateAudioJson } from './validators/rich-assets/audio.js';
import { validateButtonsJson, validateButtonOption, validateVariableObject, } from './validators/rich-assets/buttons.js';
import { validateCarouselJson, validateCarouselItem, validateAdditionalCtaItem, } from './validators/rich-assets/carousel.js';
import { validateDeepLinkJson } from './validators/rich-assets/deep-link.js';
import { validateDynamicEmbedJson } from './validators/rich-assets/dynamic-embed.js';
import { validateFileUploadJson } from './validators/rich-assets/file-upload.js';
import { validateImageJson } from './validators/rich-assets/image.js';
import { validateImageButtonJson, validateImageButtonOption, } from './validators/rich-assets/image-button.js';
import { validateListPickerJson, validateListPickerOption, } from './validators/rich-assets/list-picker.js';
import { validatePersistentMenuJson, validatePersistentMenuOption, } from './validators/rich-assets/persistent-menu.js';
import { validateQuickReplyJson, validateQuickReplyOption, } from './validators/rich-assets/quick-reply.js';
import { validateRichAssetUnknown } from './validators/rich-assets/unknown.js';
import { validateStarJson, validateStarOptionsArrayProperty, } from './validators/rich-assets/star.js';
import { validatePifFile } from './validators/json-file.js';
/**
 * Register custom validation checks.
 */
export function registerValidationChecks(services) {
    const registry = services.validation.ValidationRegistry;
    const validator = services.validation.PypestreamPifValidator;
    // Create a wrapper for validateNode that includes services
    const validatePifFileWithServices = (pifFile, accept) => {
        validatePifFile(pifFile, accept, services);
    };
    const checks = {
        PifFile: validatePifFileWithServices,
        // validations for nested structures
        AdditionalCtaItem: validateAdditionalCtaItem,
        AudioJson: validateAudioJson,
        ButtonsJson: validateButtonsJson,
        ButtonOption: validateButtonOption,
        VariableObject: validateVariableObject,
        CarouselJson: validateCarouselJson,
        CarouselItem: validateCarouselItem,
        DeepLinkJson: validateDeepLinkJson,
        DynamicEmbedJson: validateDynamicEmbedJson,
        FileUploadJson: validateFileUploadJson,
        ImageJson: validateImageJson,
        ImageButtonJson: validateImageButtonJson,
        ImageButtonOption: validateImageButtonOption,
        ListPickerJson: validateListPickerJson,
        ListPickerOption: validateListPickerOption,
        PersistentMenuJson: validatePersistentMenuJson,
        PersistentMenuOption: validatePersistentMenuOption,
        QuickReplyJson: validateQuickReplyJson,
        QuickReplyOption: validateQuickReplyOption,
        RichAssetUnknown: validateRichAssetUnknown,
        StarJson: validateStarJson,
        StarOptionsArrayProperty: validateStarOptionsArrayProperty,
    };
    registry.register(checks, validator);
}
export class PypestreamPifValidator {
}
//# sourceMappingURL=pypestream-pif-validator.js.map